import { render, staticRenderFns } from "./post-hack-gb-whatsapp.vue?vue&type=template&id=5469d47c"
import script from "./post-hack-gb-whatsapp.vue?vue&type=script&lang=js"
export * from "./post-hack-gb-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports